(function() {
    // DOM Elements
    var headerWrapper = document.getElementById('headerWrapper');
    var mobileMenuToggle = document.getElementById('mobileMenuToggle');
    var mobileMenu = document.getElementById('mobileMenu');
    var mobileOverlay = document.getElementById('mobileOverlay');
    var mobileMenuClose = document.getElementById('mobileMenuClose');

    // Open Mobile Menu
    function openMobileMenu() {
        if (mobileMenu && mobileOverlay) {
            mobileMenu.classList.add('active');
            mobileOverlay.classList.add('active');
            document.body.style.overflow = 'hidden';
        }
    }

    // Close Mobile Menu
    function closeMobileMenu() {
        if (mobileMenu && mobileOverlay) {
            mobileMenu.classList.remove('active');
            mobileOverlay.classList.remove('active');
            document.body.style.overflow = '';
        }
    }

    // Event Listeners
    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', openMobileMenu);
    }

    if (mobileMenuClose) {
        mobileMenuClose.addEventListener('click', closeMobileMenu);
    }

    if (mobileOverlay) {
        mobileOverlay.addEventListener('click', closeMobileMenu);
    }

    // Close menu when clicking nav links
    var mobileNavLinks = document.querySelectorAll('.mobile-nav-link');
    mobileNavLinks.forEach(function(link) {
        link.addEventListener('click', closeMobileMenu);
    });

    // Sticky header shadow on scroll
    window.addEventListener('scroll', function() {
        if (headerWrapper) {
            if (window.scrollY > 10) {
                headerWrapper.style.boxShadow = '0 2px 20px rgba(0, 0, 0, 0.08)';
            } else {
                headerWrapper.style.boxShadow = 'none';
            }
        }
    });

    // Close mobile menu on resize to desktop
    window.addEventListener('resize', function() {
        if (window.innerWidth > 900) {
            closeMobileMenu();
        }
    });

    // Close mobile menu when pressing Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('active')) {
            closeMobileMenu();
        }
    });
})();